import { version } from './version';
export var userAgents = [{
  segment: 'autocomplete-core',
  version: version
}];